const initialState = {
    anchor: 'left',
    produtor: [],
    open: false,
    id: '',
    nome: '',
    endereco: '',
    numero_matricula: '',
    telefone: '',
    inscricao_municipal: '',
    inscricao_estadual: '',
    id_usuario: '',
};

export function produtor(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_PRODUTOR':
            return {
                ...state,
                produtor: action.produtor
            };
        case 'PRODUTOR_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                endereco: action.endereco,
                numero_matricula: action.numero_matricula,
                telefone: action.telefone,
                inscricao_municipal: action.inscricao_municipal,
                inscricao_estadual: action.inscricao_estadual,
                id_usuario: action.id_usuario
            };
        case 'PRODUTOR_CLEAR':
            return {
                ...state,
                anchor: 'left',
                produtor: [],
                open: false,
                id: '',
                nome: '',
                endereco: '',
                numero_matricula: '',
                telefone: '',
                inscricao_municipal: '',
                inscricao_estadual: '',
                id_usuario: ''
            };
        case "PRODUTOR_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
